"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifElseTransformCreator = exports.isIfElseCalculation = exports.IfElseType = void 0;
var EffectiveDefinition_1 = require("../../models/EffectiveDefinition");
var SimplePredicateCalculation_1 = require("./SimplePredicateCalculation");
exports.IfElseType = 'if-else';
var isIfElseCalculation = function (calc) {
    return calc !== undefined && calc.type === exports.IfElseType;
};
exports.isIfElseCalculation = isIfElseCalculation;
var ifElseTransformCreator = function (definition, name) {
    var column = definition.schema[name];
    if (!(0, EffectiveDefinition_1.isCalculatedColumnSchema)(column)) {
        throw new Error("Could not find calculated column with name: ".concat(name));
    }
    var calc = column.calculation;
    if (!(0, exports.isIfElseCalculation)(calc)) {
        throw new Error("Could not find if-else column with name: ".concat(name));
    }
    return function (sourceTable, windowedTable) {
        return windowedTable.map(function (row) {
            var _a;
            var result = calc.branches.find(function (value) {
                if (value.predicate === undefined) {
                    return value;
                }
                return (0, SimplePredicateCalculation_1.applySimplePredicate)(value.predicate, row);
            });
            return __assign(__assign({}, row), (_a = {}, _a[name] = result === null || result === void 0 ? void 0 : result.result, _a));
        });
    };
};
exports.ifElseTransformCreator = ifElseTransformCreator;
//# sourceMappingURL=IfElseCalculation.js.map